[
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_authorizedDeployer",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "constructor"
  },
  {
    "inputs": [],
    "name": "AlreadyRegistered",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "CannotReviewSelf",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidAddresses",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidBuyer",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidDeployer",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidEscrowAddress",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "InvalidSeller",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotAuthorizedDeployer",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "NotRegisteredEscrow",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "ReviewAlreadySubmitted",
    "type": "error"
  },
  {
    "inputs": [],
    "name": "UnknownEscrow",
    "type": "error"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "seller",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "buyer",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "escrow",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "amount",
        "type": "uint256"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "timestamp",
        "type": "uint256"
      }
    ],
    "name": "HandOffRecorded",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "escrow",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "uint256",
        "name": "dealId",
        "type": "uint256"
      }
    ],
    "name": "HandOffRegistered",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "escrow",
        "type": "address"
      }
    ],
    "name": "HandOffRevoked",
    "type": "event"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "reviewer",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "reviewed",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "escrow",
        "type": "address"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "isPositive",
        "type": "bool"
      },
      {
        "indexed": false,
        "internalType": "bool",
        "name": "reviewedAsSeller",
        "type": "bool"
      }
    ],
    "name": "ReviewSubmitted",
    "type": "event"
  },
  {
    "inputs": [],
    "name": "AUTHORIZED_DEPLOYER",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_buyer",
        "type": "address"
      }
    ],
    "name": "getBuyerHistory",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "",
        "type": "address[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_buyer",
        "type": "address"
      }
    ],
    "name": "getBuyerHistoryLength",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_buyer",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getBuyerHistoryPage",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "page",
        "type": "address[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "name": "getEscrowFromDealId",
    "outputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_wallet",
        "type": "address"
      }
    ],
    "name": "getReputation",
    "outputs": [
      {
        "components": [
          {
            "internalType": "uint128",
            "name": "sellerTotalVolume",
            "type": "uint128"
          },
          {
            "internalType": "uint32",
            "name": "sellerDealCount",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "sellerPositiveReviews",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "sellerTotalReviews",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "buyerDealCount",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "buyerPositiveReviews",
            "type": "uint32"
          },
          {
            "internalType": "uint32",
            "name": "buyerTotalReviews",
            "type": "uint32"
          }
        ],
        "internalType": "struct HandOffReputation.ReputationData",
        "name": "",
        "type": "tuple"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_seller",
        "type": "address"
      }
    ],
    "name": "getSellerHistory",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "",
        "type": "address[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_seller",
        "type": "address"
      }
    ],
    "name": "getSellerHistoryLength",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_seller",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "offset",
        "type": "uint256"
      },
      {
        "internalType": "uint256",
        "name": "limit",
        "type": "uint256"
      }
    ],
    "name": "getSellerHistoryPage",
    "outputs": [
      {
        "internalType": "address[]",
        "name": "page",
        "type": "address[]"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_seller",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "_buyer",
        "type": "address"
      },
      {
        "internalType": "uint256",
        "name": "_amount",
        "type": "uint256"
      }
    ],
    "name": "recordCompletion",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_reviewer",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "_reviewed",
        "type": "address"
      },
      {
        "internalType": "address",
        "name": "_escrow",
        "type": "address"
      },
      {
        "internalType": "bool",
        "name": "_isPositive",
        "type": "bool"
      },
      {
        "internalType": "bool",
        "name": "_reviewedAsSeller",
        "type": "bool"
      }
    ],
    "name": "recordReview",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_escrow",
        "type": "address"
      }
    ],
    "name": "registerHandOff",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "dealId",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "",
        "type": "address"
      }
    ],
    "name": "registeredEscrows",
    "outputs": [
      {
        "internalType": "bool",
        "name": "",
        "type": "bool"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_escrow",
        "type": "address"
      }
    ],
    "name": "revokeHandOff",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  },
  {
    "inputs": [],
    "name": "totalDeals",
    "outputs": [
      {
        "internalType": "uint256",
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  },
  {
    "anonymous": false,
    "inputs": [
      {
        "indexed": true,
        "internalType": "address",
        "name": "previousDeployer",
        "type": "address"
      },
      {
        "indexed": true,
        "internalType": "address",
        "name": "newDeployer",
        "type": "address"
      }
    ],
    "name": "DeployerTransferred",
    "type": "event"
  },
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "_newDeployer",
        "type": "address"
      }
    ],
    "name": "transferDeployer",
    "outputs": [],
    "stateMutability": "nonpayable",
    "type": "function"
  }
]